<body>
  <!-- Login -->
  @if (!toTpVerification) {
    <div class="container col-lg-6">
      <h1 class="text-center">Login</h1>
      <div class="card">
        <div class="card-body">
          <form class="form-group">
            @if (error) {
              @if (error) {
                <div [innerHTML]="displayError(error)" style="color : red"></div>
              }
            }
            <div class="form-group">
              <label for="email">User Name :</label>
              <input type="text" class="form-control" id="username" [(ngModel)]="username" placeholder="Enter User Name"
                name="username">
              </div>
              <label for="pwd">Password:</label>
              <!-- <div class="form-group input-group">
              <input type="password" class="form-control" [(ngModel)]="password" id="password"
                placeholder="Enter password" name="password" formControlName="password">
              </div> -->
              <!-- <mat-form-field> -->
              <input type="password" class="form-control"  id="password"
                placeholder="Enter password" name="password" #password />
                <mat-icon class="eye"
                  style="cursor: pointer;position: relative;"
                  matSuffix
                  (mousedown)="password.type == 'text' ? password.type = 'password': password.type = 'text'"
                  [inline]="true">
                  {{ password.type == "password" ? "visibility_off" : "visibility" }}
                </mat-icon>
                <br>
                  @if (systemParameters[0]?.parameterValue1 != null && systemParameters[0]?.parameterValue1 != undefined && systemParameters[0]?.parameterValue1 != '') {
                    <p style="color: red;font-weight: bold;">{{systemParameters[0]?.parameterValue1}}</p>
                  }
                <!-- </mat-form-field> -->
                <button (click)=doSignin() class="btn btn-success">Login</button>
              </form>
            </div>
          </div>
        </div>
      }

      <!-- MFA - TOTP -->
      @if (toTpVerification) {
        <div class="container col-lg-6">
          <h1 class="text-center" style="color: white;">Multi-Factor Authentication</h1>
          @if (selectedMfa == null) {
            @if (mfaTypes.length > 0) {
              <div class="mfa-container">
                <h3>Select an option to sign in:</h3>
                <ul class="mfa-options">
                  @for (type of mfaTypes; track type) {
                    <li>
                      <button (click)="signInWith(type)">
                        Sign in with {{ type.type.parameterDesc }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            } @else {
              <p class="no-options">No sign-in options available.</p>
            }
          }
          <!-- EMAIL -->
          @if (selectedMfa != null && selectedMfa.type.parameterCode == 'EMAIL') {
            <div class="card">
              <div class="card-body">
                <form class="form-group">
                  @if (error) {
                    <div style="color : red;">{{error}}</div>
                  }
                  <div class="form-group">
                    <label for="emailCode">Code sent to Email on File</label>
                    <input type="text" class="form-control" id="emailCode" [(ngModel)]="verificationCode" placeholder="Enter 6 Digit Code"
                      name="emailCode" autocomplete="off">
                    </div>
                    <div style="text-align: -webkit-center;">
                      <button (click)=doSignin() class="btn btn-success">Login</button>
                      <br>
                        <button class="BtnLnk" mat-raised-button color="primary" style="color: black;"
                        (click)="doSignin()">Resend code</button>
                      </div>
                    </form>
                  </div>
                </div>
              }
              <!-- TOTP -->
              @if (selectedMfa != null && selectedMfa.type.parameterCode == 'TOTP') {
                @if (qrCode != null && qrCode.length != 0) {
                  <div style="text-align: center;">
                    <img [src]="qrCode" />
                    <p style="font-weight: bold;color: red;">For your security, please follow the steps below</p>
                    <ol style="text-align: left;">
                      <li>Download an Authenticator app of your choice to your phone.</li>
                      <li>Open the installed application on your phone and create a new Account.</li>
                      <li>You will be given an option to a Scan QR Code. Scan the QR Code provided above.</li>
                      <li>Once this is completed, a new 6-digit code will be generated every 30 seconds on your phone.</li>
                      <li>You must input the 6-digit code when signing into this application in the future.</li>
                    </ol>
                    <p style="font-weight: bold;color: red;">Complete the steps above before continuing.</p>
                    <button (click)=clearQrCode() class="btn btn-success">Continue</button>
                  </div>
                }
                @if (qrCode == null || qrCode.length == 0) {
                  <div class="card">
                    <div class="card-body">
                      <form class="form-group">
                        @if (error) {
                          <div style="color : red;">{{error}}</div>
                        }
                        <div class="form-group">
                          <label for="totpCode">Code :</label>
                          <input type="text" class="form-control" id="totpCode" [(ngModel)]="verificationCode" placeholder="Enter 6 Digit Code"
                            name="totpCode" autocomplete="off">
                          </div>
                          <button (click)=doSignin() class="btn btn-success">Login</button>
                        </form>
                      </div>
                    </div>
                  }
                }
              </div>
            }

          </body>